export const assetPath = process.env.NEXT_PUBLIC_ASSET_LOCATION;
